import React from 'react';
import { combineClassNames } from '../../../core/css';
import { useTranslate } from '../../../core/translate';
import { useModelInfo } from '../../common/ModelInfoContext';
import { template } from 'lodash';

const FallbackCgi = ({
  fullSize = false,
  fullWidth = false,
  hideLabel = false,
  noPadding = false,
  transparent = false,
}) => {
  const translate = useTranslate();
  const modelInfo = useModelInfo();
  const { assetsUrlTemplate, brandBase } = modelInfo;
  const fallback = template(assetsUrlTemplate)({
    filename: 'fallback.svg',
  });
  const imageUnavailableLabel = translate('fallback.image.label.v3');

  return (
    <div
      className={combineClassNames(
        'fallback-cgi__container',
        fullSize ? 'fallback-cgi__container--full-size' : '',
        fullWidth ? 'fallback-cgi__container--full-width' : '',
        noPadding ? 'fallback-cgi__container--no-padding' : '',
        transparent ? 'fallback-cgi__container--transparent' : ''
      )}
      role={'contentinfo'}
      aria-label={imageUnavailableLabel}>
      <img className="fallback-cgi__logo" src={fallback} alt={brandBase} />
      {!hideLabel ? (
        <span className="fallback-cgi__label">{imageUnavailableLabel}</span>
      ) : null}
    </div>
  );
};

export default FallbackCgi;
